"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get demoAtomicBlock () {
        return demoAtomicBlock;
    },
    get demoContent () {
        return demoContent;
    },
    get demoContentAttacks () {
        return demoContentAttacks;
    },
    get demoEmptyBlock () {
        return demoEmptyBlock;
    },
    get demoTextBlock () {
        return demoTextBlock;
    }
});
const _object_spread = require("@swc/helpers/_/_object_spread");
const _object_spread_props = require("@swc/helpers/_/_object_spread_props");
const _deviations = require("../deviations");
const demoEmptyBlock = {
    text: '',
    type: 'unstyled',
    depth: 0,
    inlineStyleRanges: [],
    entityRanges: [],
    data: {}
};
const demoTextBlock = {
    text: 'Lorem ipsum',
    type: 'unstyled',
    depth: 0,
    inlineStyleRanges: [
        {
            offset: 0,
            length: 11,
            style: 'inline-header-two'
        }
    ],
    entityRanges: [],
    data: {}
};
const demoAtomicBlock = {
    text: ' ',
    type: 'atomic',
    depth: 0,
    inlineStyleRanges: [],
    entityRanges: [
        {
            offset: 0,
            length: 1,
            key: 0
        }
    ],
    data: {}
};
const demoContent = {
    blocks: [
        _object_spread_props._(_object_spread._({}, demoTextBlock), {
            key: 'foo'
        }),
        _object_spread_props._(_object_spread._({}, demoAtomicBlock), {
            key: '4imv2'
        }),
        {
            key: 'fe7ur',
            text: 'Lorem ipsum, consectetur adipiscing elit. Nam luctus vel neque nec ultricies. Vivamus congue semper ex nec dapibus. Vivamus pretium lobortis ligula, sit amet lobortis dolor sodales ac. Praesent maximus lorem eu lorem ullamcorper, viverra porttitor erat accumsan. :D  Consectetur adipiscing elit. Nam luctus vel neque nec ultricies. Vivamus congue semper ex nec dapibus. Vivamus pretium lobortis ligula, sit amet lobortis dolor sodales.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 185,
                    length: 43,
                    style: 'BOLD'
                }
            ],
            entityRanges: [
                {
                    offset: 263,
                    length: 2,
                    key: 1
                }
            ],
            data: {}
        },
        {
            key: 'b4klk',
            text: 'Vestibulum semper ligula ut feugiat tristique.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 46,
                    style: 'inline-header-three'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: '1vroi',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'cqa40',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 2
                }
            ],
            data: {}
        },
        {
            key: '446em',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '3co1o',
            text: 'Maecenas maximus urna id est tincidunt, euismod faucibus nulla feugiat. Nunc consequat, turpis eget dapibus suscipit',
            type: 'ordered-list-item',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 16,
                    key: 3
                }
            ],
            data: {}
        },
        {
            key: '349s8',
            text: 'Massa ligula mattis mauris',
            type: 'ordered-list-item',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 26,
                    style: 'ITALIC'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: '205os',
            text: 'Vel ultrices dolor diam eu massa',
            type: 'ordered-list-item',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 12,
                    style: 'UNDERLINE'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: 'do60r',
            text: 'Sed suscipit bibendum sapien',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 28,
                    style: 'inline-header-three'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: '4uh12',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '9c7e7',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 4
                }
            ],
            data: {}
        },
        {
            key: '21aoj',
            text: 'Porttitor viverra nisl maximus rhoncus. Cras convallis libero ante, et condimentum velit tincidunt id. Ut ipsum leo, venenatis a dictum non, sollicitudin ac urna. Praesent fringilla at ligula in lacinia. In quam leo, molestie sed varius vel, molestie id ex. Nunc aliquam fringilla laoreet. Donec in lobortis lorem, sed posuere nisi. Pellentesque egestas urna eget tempus suscipit. Duis at odio ut dui efficitur rutrum at pretium nisi. Suspendisse eget dignissim nibh, et aliquam magna. Ut et malesuada ipsum, sed elementum orci. Ut quis tortor facilisis, feugiat tellus non, elementum nunc. Nam in risus orci.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '88gia',
            text: 'Donec bibendum faucibus ante.',
            type: 'unordered-list-item',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'b1lae',
            text: 'Mauris luctus, turpis eget efficitur eleifend, enim lacus dictum eros, in aliquet elit enim at velit.',
            type: 'unordered-list-item',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'a243t',
            text: 'Duis lacinia velit vitae suscipit gravida.',
            type: 'unordered-list-item',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'duon0',
            text: 'Nullam ultricies, tellus nec semper volutpat.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '3teui',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '4fst4',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 5
                }
            ],
            data: {}
        },
        {
            key: 'gelh',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'cglne',
            text: 'Odio dui sodales diam, fringilla efficitur ligula enim non massa.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '88r9u',
            text: 'Etiam tristique turpis sed lectus cursus tempor porta sollicitudin',
            type: 'blockquote',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '8cov0',
            text: 'Vivamus sit amet neque non elit pellentesque posuere vitae sed ex. Integer cursus imperdiet sapien, a fringilla enim bibendum vel.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'e5g7l',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 6
                }
            ],
            data: {}
        },
        {
            key: 'ad8ut',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'drkda',
            text: 'Morbi bibendum molestie molestie. Donec tristique ipsum dui, et tristique magna molestie ut. Curabitur venenatis arcu vehicula diam vestibulum, in eleifend tellus sodales.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'dc75r',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'b9ndl',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 7
                }
            ],
            data: {}
        },
        {
            key: 'aioc3',
            text: 'Fusce lacus dui, euismod at tincidunt ac, dapibus quis enim. Sed ut molestie orci. Duis blandit euismod porta. Duis non auctor lorem. In condimentum tellus vitae fringilla sagittis. Quisque ullamcorper malesuada consectetur.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 111,
                    length: 21,
                    style: 'UNDERLINE'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: 'sjk3n',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 8
                }
            ],
            data: {}
        }
    ],
    entityMap: {
        '0': {
            type: 'wix-draft-plugin-image',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    alignment: 'center',
                    size: 'content',
                    showTitle: true,
                    showDescription: true,
                    key: '4imv2'
                },
                data: _deviations.deviationsByType.image[0]
            }
        },
        '1': {
            type: 'DA_OFF_EMOTE',
            mutability: 'IMMUTABLE',
            data: {
                emote: ':D'
            }
        },
        '2': {
            type: 'wix-draft-plugin-image',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    alignment: 'center',
                    size: 'content',
                    showTitle: true,
                    showDescription: true,
                    key: 'cqa40'
                },
                data: _deviations.deviationsByType.image[1]
            }
        },
        '3': {
            type: 'LINK',
            mutability: 'MUTABLE',
            data: {
                url: 'https://example.com',
                target: '_self',
                rel: 'noopener'
            }
        },
        '4': {
            type: 'wix-draft-plugin-image',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    alignment: 'right',
                    size: 'small',
                    showTitle: true,
                    showDescription: true,
                    key: '9c7e7'
                },
                data: _deviations.deviationsByType.image[3]
            }
        },
        '5': {
            type: 'wix-draft-plugin-gallery',
            mutability: 'IMMUTABLE',
            data: {
                items: [],
                styles: {
                    galleryLayout: 2,
                    gallerySizeType: 'px',
                    gallerySizePx: 300,
                    oneRow: false,
                    cubeRatio: 1,
                    galleryThumbnailsAlignment: 'bottom',
                    isVertical: false,
                    numberOfImagesPerRow: 3,
                    imageMargin: 8,
                    thumbnailSpacings: 0,
                    cubeType: 'fill',
                    enableInfiniteScroll: true,
                    titlePlacement: 'SHOW_ON_HOVER',
                    allowHover: false,
                    itemClick: 'link',
                    showArrows: false,
                    gridStyle: 1,
                    loveButton: false,
                    allowSocial: false,
                    allowDownload: false
                },
                config: {
                    alignment: 'center',
                    size: 'content',
                    layout: 'small',
                    spacing: 0,
                    key: '4fst4'
                },
                data: [
                    _deviations.deviationsByType.image[3],
                    _deviations.deviationsByType.image[4],
                    _deviations.deviationsByType.image[5],
                    _deviations.deviationsByType.image[6],
                    _deviations.deviationsByType.image[7],
                    _deviations.deviationsByType.image[8]
                ]
            }
        },
        '6': {
            type: 'wix-draft-plugin-image',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    alignment: 'center',
                    size: 'fullWidth',
                    showTitle: true,
                    showDescription: true,
                    key: 'e5g7l'
                },
                data: _deviations.deviationsByType.image[0]
            }
        },
        '7': {
            type: 'wix-draft-plugin-video',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    size: 'content',
                    alignment: 'center'
                },
                src: 'https://www.youtube.com/watch?v=NW9Yq99FeTU'
            }
        },
        '8': {
            type: 'wix-draft-plugin-link-preview',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    size: 'small',
                    alignment: 'center'
                },
                description: 'Lollapalooza is back this summer, with proof of vaccination or a negative COVID test required for entry. With Pitchfork Festival and Riot Fest also returning, Chicago prepares for a loud reopening.',
                thumbnail_url: 'https://media.npr.org/assets/img/2021/05/18/gettyimages-584909622_wide-4957e59f98e0350fc47cfa00a3f68344119c460d.jpg?s=1400',
                title: 'Foo Fighters Headline Lollapalooza As Chicago Summer Festival Season Opens Up'
            }
        }
    }
};
function attackDeviation(deviation) {
    var _deviation_files;
    // attack files
    const badFiles = (_deviation_files = deviation.files) === null || _deviation_files === void 0 ? void 0 : _deviation_files.map((f)=>{
        const n = _object_spread._({}, f);
        n.src = 'https://bad.com/bad.gif';
        return n;
    });
    return _object_spread_props._(_object_spread._({}, deviation), {
        author: {
            type: 'admin',
            userId: 1,
            username: 'muteor',
            usericon: ''
        },
        files: badFiles,
        url: 'https://bad.com/bad.html'
    });
}
const demoContentAttacks = {
    blocks: [
        {
            key: 'foo',
            // Attack classic XSS
            text: 'Lorem ipsum<script>alert("xss")</script><img onerror="alert(\'XSS1\')" />',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 11,
                    style: 'inline-header-two'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: '4imv2',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 0
                }
            ],
            data: {}
        },
        {
            key: 'fe7ur',
            text: 'Lorem ipsum, consectetur adipiscing elit. Nam luctus vel neque nec ultricies. Vivamus congue semper ex nec dapibus. Vivamus pretium lobortis ligula, sit amet lobortis dolor sodales ac. Praesent maximus lorem eu lorem ullamcorper, viverra porttitor erat accumsan. :D  Consectetur adipiscing elit. Nam luctus vel neque nec ultricies. Vivamus congue semper ex nec dapibus. Vivamus pretium lobortis ligula, sit amet lobortis dolor sodales.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 185,
                    length: 43,
                    style: 'BOLD'
                }
            ],
            entityRanges: [
                {
                    offset: 263,
                    length: 2,
                    key: 1
                }
            ],
            data: {}
        },
        {
            key: 'b4klk',
            text: 'Vestibulum semper ligula ut feugiat tristique.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 46,
                    style: 'inline-header-three'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: '1vroi',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'cqa40',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 2
                }
            ],
            data: {}
        },
        {
            key: '446em',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '3co1o',
            text: 'Maecenas maximus urna id est tincidunt, euismod faucibus nulla feugiat. Nunc consequat, turpis eget dapibus suscipit',
            type: 'ordered-list-item',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 16,
                    key: 3
                }
            ],
            data: {}
        },
        {
            key: '349s8',
            text: 'Massa ligula mattis mauris',
            type: 'ordered-list-item',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 26,
                    style: 'ITALIC'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: '205os',
            text: 'Vel ultrices dolor diam eu massa',
            type: 'ordered-list-item',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 12,
                    style: 'UNDERLINE'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: 'do60r',
            text: 'Sed suscipit bibendum sapien',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 0,
                    length: 28,
                    style: 'inline-header-three'
                }
            ],
            entityRanges: [],
            data: {}
        },
        {
            key: '4uh12',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '9c7e7',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 4
                }
            ],
            data: {}
        },
        {
            key: '21aoj',
            text: 'Porttitor viverra nisl maximus rhoncus. Cras convallis libero ante, et condimentum velit tincidunt id. Ut ipsum leo, venenatis a dictum non, sollicitudin ac urna. Praesent fringilla at ligula in lacinia. In quam leo, molestie sed varius vel, molestie id ex. Nunc aliquam fringilla laoreet. Donec in lobortis lorem, sed posuere nisi. Pellentesque egestas urna eget tempus suscipit. Duis at odio ut dui efficitur rutrum at pretium nisi. Suspendisse eget dignissim nibh, et aliquam magna. Ut et malesuada ipsum, sed elementum orci. Ut quis tortor facilisis, feugiat tellus non, elementum nunc. Nam in risus orci.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '88gia',
            text: 'Donec bibendum faucibus ante.',
            type: 'unordered-list-item',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'b1lae',
            text: 'Mauris luctus, turpis eget efficitur eleifend, enim lacus dictum eros, in aliquet elit enim at velit.',
            type: 'unordered-list-item',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'a243t',
            text: 'Duis lacinia velit vitae suscipit gravida.',
            type: 'unordered-list-item',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'duon0',
            text: 'Nullam ultricies, tellus nec semper volutpat.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '3teui',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '4fst4',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 5
                }
            ],
            data: {}
        },
        {
            key: 'gelh',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'cglne',
            text: 'Odio dui sodales diam, fringilla efficitur ligula enim non massa.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '88r9u',
            text: 'Etiam tristique turpis sed lectus cursus tempor porta sollicitudin',
            type: 'blockquote',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: '8cov0',
            text: 'Vivamus sit amet neque non elit pellentesque posuere vitae sed ex. Integer cursus imperdiet sapien, a fringilla enim bibendum vel.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'e5g7l',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 6
                }
            ],
            data: {}
        },
        {
            key: 'ad8ut',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'drkda',
            text: 'Morbi bibendum molestie molestie. Donec tristique ipsum dui, et tristique magna molestie ut. Curabitur venenatis arcu vehicula diam vestibulum, in eleifend tellus sodales.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'dc75r',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        },
        {
            key: 'b9ndl',
            text: ' ',
            type: 'atomic',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [
                {
                    offset: 0,
                    length: 1,
                    key: 7
                }
            ],
            data: {}
        },
        {
            key: 'aioc3',
            text: 'Fusce lacus dui, euismod at tincidunt ac, dapibus quis enim. Sed ut molestie orci. Duis blandit euismod porta. Duis non auctor lorem. In condimentum tellus vitae fringilla sagittis. Quisque ullamcorper malesuada consectetur.',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [
                {
                    offset: 111,
                    length: 21,
                    style: 'UNDERLINE'
                }
            ],
            entityRanges: [],
            data: {}
        }
    ],
    entityMap: {
        '0': {
            type: 'wix-draft-plugin-image',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    alignment: 'center',
                    size: 'content',
                    showTitle: true,
                    showDescription: true,
                    key: '4imv2'
                },
                data: attackDeviation(_deviations.deviationsByType.image[0])
            }
        },
        '1': {
            type: 'DA_OFF_EMOTE',
            mutability: 'IMMUTABLE',
            data: {
                emote: ':D'
            }
        },
        '2': {
            type: 'wix-draft-plugin-image',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    alignment: 'center',
                    size: 'content',
                    showTitle: true,
                    showDescription: true,
                    key: 'cqa40'
                },
                data: attackDeviation(_deviations.deviationsByType.image[1])
            }
        },
        '3': {
            type: 'LINK',
            mutability: 'MUTABLE',
            // Attack rel and target
            data: {
                url: 'https://example.com',
                target: '',
                rel: ''
            }
        },
        '4': {
            type: 'wix-draft-plugin-image',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    alignment: 'right',
                    size: 'small',
                    showTitle: true,
                    showDescription: true,
                    key: '9c7e7'
                },
                data: attackDeviation(_deviations.deviationsByType.image[3])
            }
        },
        '5': {
            type: 'wix-draft-plugin-gallery',
            mutability: 'IMMUTABLE',
            data: {
                items: [],
                styles: {
                    galleryLayout: 2,
                    gallerySizeType: 'px',
                    gallerySizePx: 300,
                    oneRow: false,
                    cubeRatio: 1,
                    galleryThumbnailsAlignment: 'bottom',
                    isVertical: false,
                    numberOfImagesPerRow: 3,
                    imageMargin: 8,
                    thumbnailSpacings: 0,
                    cubeType: 'fill',
                    enableInfiniteScroll: true,
                    titlePlacement: 'SHOW_ON_HOVER',
                    allowHover: false,
                    itemClick: 'link',
                    showArrows: false,
                    gridStyle: 1,
                    loveButton: false,
                    allowSocial: false,
                    allowDownload: false
                },
                config: {
                    alignment: 'center',
                    size: 'content',
                    layout: 'small',
                    spacing: 0,
                    key: '4fst4'
                },
                data: [
                    attackDeviation(_deviations.deviationsByType.image[3]),
                    attackDeviation(_deviations.deviationsByType.image[4]),
                    attackDeviation(_deviations.deviationsByType.image[5]),
                    attackDeviation(_deviations.deviationsByType.image[6]),
                    attackDeviation(_deviations.deviationsByType.image[7]),
                    attackDeviation(_deviations.deviationsByType.image[8])
                ]
            }
        },
        '6': {
            type: 'wix-draft-plugin-image',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    alignment: 'center',
                    size: 'fullWidth',
                    showTitle: true,
                    showDescription: true,
                    key: 'e5g7l'
                },
                data: attackDeviation(_deviations.deviationsByType.image[0])
            }
        },
        '7': {
            type: 'wix-draft-plugin-video',
            mutability: 'IMMUTABLE',
            data: {
                config: {
                    size: 'content',
                    alignment: 'center'
                },
                // Attack video
                src: 'https://www.bad.com/bad.html" onerror="alert(\'XSS\')"'
            }
        }
    }
};
